import { pushToDataLayer } from '../../pushToDataLayer';
import {
  GTMEvent,
  GTMEventAttributes,
  GTMEventName,
  GTMVideoAttributes,
} from '../../types';
import { mapToGTMVideoAttributes } from '../../utils';
import { VideoAttributeInteractionInteractionEventArgs } from './types';

// THIS NEEDS TO BE IMPLEMENTED SIMILARLY TO THE OTHER EVENTS THAT REQUIRE VEHICLE DATA
export function videoAttributeInteractionInteractionEvent({
  videoAttributes,
  vehicleData,
}: VideoAttributeInteractionInteractionEventArgs) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.VIDEO_ATTRIBUTE_INTERACTION,
  };

  const gtmVideoAttributes: GTMVideoAttributes =
    mapToGTMVideoAttributes(videoAttributes);

  pushToDataLayer({
    ...eventAttributes,
    ...gtmVideoAttributes,
    ...vehicleData,
  });
}
